import { country } from '@/constants/country';
import Script from 'next/script';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { safeOpenJarabot } from '@/utils/jarabot';
import Cookies from 'js-cookie';
export function JaraBotScript() {
  const {
    asPath
  } = useRouter();
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        if (!sessionStorage.getItem('jarabotSessionActive')) {
          Cookies.remove('cw_conversation', {
            path: '/',
            secure: true,
            sameSite: 'Strict'
          });
          sessionStorage.setItem('jarabotSessionActive', '1');
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('SessionStorage not available:', error);
    }
  }, []);
  useEffect(() => {
    if (country !== 'CZ' && country !== 'SK' && country !== 'HU') {
      return;
    }
    const hash = asPath.split('#')[1];
    if (hash === 'openChat') {
      const timeoutId = setTimeout(() => safeOpenJarabot(), 0);
      return () => clearTimeout(timeoutId);
    }
  }, [asPath]);
  if (country !== 'CZ' && country !== 'SK' && country !== 'HU') {
    return null;
  }
  if (country === 'SK') {
    return <Script strategy="lazyOnload" id="jarabot-script">
				{`
					window.chatwootSettings = {"locale":"sk","position":"right","type":"expanded_bubble","launcherTitle":"Začať chat"};(function(d,t) {var BASE_URL="https://chat.jarabot.com";var g=d.createElement(t),s=d.getElementsByTagName(t)[0];g.src=BASE_URL+"/packs/js/sdk.js";g.defer = true;g.async = true;s.parentNode.insertBefore(g,s);g.onload=function(){window.chatwootSDK.run({websiteToken: 'aH824ocTPDNZQ3Mkwb4YCgKM',baseUrl: BASE_URL})}})(document,"script");
				`}
			</Script>;
  }
  if (country === 'HU') {
    return <Script strategy="lazyOnload" id="jarabot-script">
				{`
					window.chatwootSettings = {"locale":"hu","position":"right","type":"expanded_bubble","launcherTitle":"Csevegés indítása"}; (function(d,t) { var BASE_URL="https://chat.jarabot.com"; var g=d.createElement(t),s=d.getElementsByTagName(t)[0]; g.src=BASE_URL+"/packs/js/sdk.js"; g.defer = true; g.async = true; s.parentNode.insertBefore(g,s); g.onload=function(){ window.chatwootSDK.run({ websiteToken: 'Wdkghaj4Qeri3Xvnsp38hb8P', baseUrl: BASE_URL }) } })(document,"script");
				`}
			</Script>;
  }
  return <Script strategy="lazyOnload" id="jarabot-script">
			{`
				window.chatwootSettings = {"locale":"cz","position":"right","type":"expanded_bubble","launcherTitle":"Zahájit chat"}; (function(d,t) { var BASE_URL="https://chat.jarabot.com"; var g=d.createElement(t),s=d.getElementsByTagName(t)[0]; g.src=BASE_URL+"/packs/js/sdk.js"; g.defer = true; g.async = true; s.parentNode.insertBefore(g,s); g.onload=function(){ window.chatwootSDK.run({ websiteToken: 'QzKeYgDh1g9nuqawg59t8TUw', baseUrl: BASE_URL }) } })(document,"script");
			`}
		</Script>;
}